import React, { useEffect, useState } from "react";
import PricingHeader from "./PricingHeader";
import PaymentInfo from "./PaymentInfo";
import PaymentDetails from "./PaymentDetails";
import FadeContainer from "./FadeContainer";
import { useRouteMatch, useHistory, Redirect } from "react-router-dom";
import API from "../../../utils/axios";
import { setUser } from "../../../store/actions/auth";
import { connect } from "react-redux";
import { useSnackbar } from "notistack";
import { plans } from "../../data/plans";
import {
  resetProject,
  getProjectDetails
} from "../../../store/actions/project";
import { Box } from "@material-ui/core";
import { setApps } from "../../../store/actions/account";
import mixpanelWrapper from "../../../utils/mixpanel";

function CustomizePlan({
  handleClose,
  open,
  setCurrentDialog,
  chosenPlan,
  setActiveModal,
  getProjectDetails,
  currency,
  vehiclesCount,
  setLoading,
  plan,
  payment,
  organisation,
  resetProject,
  setUser,
  setApps
}) {
  const [stripeOpen, setStripeOpen] = useState(false);

  const subscribed = organisation?.subscription_id;
  const trial = organisation?.subscription_status === "trialing";

  const billingNeeded = ["trialing", "canceled"].includes(
    organisation?.subscription_status
  );

  let match = useRouteMatch("/payment/:planId");
  let history = useHistory();

  const { enqueueSnackbar } = useSnackbar();
  chosenPlan = plans.find(plan => plan.link === match.params.planId);
  const oldPlan =
    plan.type !== "free" && chosenPlan && plan.type !== chosenPlan.name
      ? plan.type
      : null;
  useEffect(() => {
    mixpanelWrapper.track("Plan Select", {
      "Selected Plan Name": chosenPlan.title,
      Frequency: "monthly",
      Revenue:
        chosenPlan.name === plans[0].name
          ? chosenPlan.price
          : vehiclesCount * chosenPlan.price
    });
  }, []);

  return chosenPlan ? (
    <FadeContainer open={open}>
      <PricingHeader
        title={payment ? "Confirm changes to plan" : "Customize your plan"}
        handleClose={handleClose}
      />
      <Box overflow="auto">
        <PaymentDetails
          showOverview={true}
          chosenPlan={chosenPlan}
          setActiveModal={setActiveModal}
          currency={currency}
          stripeOpen={stripeOpen}
          oldPlan={oldPlan}
        />
        <PaymentInfo
          setCurrentDialog={setCurrentDialog}
          showPrice={!oldPlan || trial}
          oldPlan={oldPlan}
          title={
            oldPlan && !trial ? "Changes apply immediately" : "Billed monthly"
          }
          subtitle={
            oldPlan && !trial
              ? "Bill will be prorated at next cycle. Change or cancel at anytime."
              : `You are paying for ${vehiclesCount} ${
                  vehiclesCount === 1 ? "vehicle" : "vehicles"
                }. If you add or remove vehicles, this amount will be recalculated.`
          }
          setActiveModal={setActiveModal}
          btn={{
            text: !payment || billingNeeded ? "Add billing details" : "Confirm",
            action: () => {
              if (payment && !billingNeeded) {
                // Define request type (adding or updating)
                const method = subscribed ? "patch" : "post";

                setLoading(true);
                API[method](`/v1/stripe/subscriptions`, {
                  plan_type: chosenPlan.name,
                  vehicles:
                    chosenPlan.name === "individual" ? 1 : vehiclesCount,
                  currency: currency.string.toLowerCase()
                })
                  .then(subscriptionResponse => {
                    Promise.all([
                      API.get("v1/users/profile"),
                      API.get("/v1/apps")
                    ])
                      .then(res => {
                        setUser(res[0].data);
                        setApps(res[1].data || []);
                      })
                      .finally(() => {
                        sessionStorage.removeItem("currentProject");
                        resetProject();
                        if (chosenPlan.name === plans[0].name) {
                          getProjectDetails();
                        }
                        enqueueSnackbar("Subscription successfully updated.");
                        history.replace(`/payment/success`, {
                          chosenPlan: chosenPlan.title,
                          currency: currency.symbol,
                          action: "plan_change",
                          activating:
                            organisation?.subscription_status === "trialing" ||
                            organisation?.subscription_status === "canceled"
                        });
                        setLoading(false);
                      });
                  })
                  .catch(err => {
                    console.log(err);
                    enqueueSnackbar(
                      "Something went wrong, couldn't update subscription"
                    );
                    setLoading(false);
                  });
              } else {
                setActiveModal("");
                history.replace(`/payment/${chosenPlan.link}/billing`);
              }
            }
          }}
          chosenPlan={chosenPlan}
          currency={currency}
          stripeOpen={stripeOpen}
          setStripeOpen={setStripeOpen}
        />
      </Box>
    </FadeContainer>
  ) : (
    <>
      <Redirect to="/payment/select-plan" />
    </>
  );
}

const mapStateToProps = state => ({
  vehiclesCount: state.project.vehicleTypes.length,
  payment: state.account.payment,
  organisation:
    state.auth.userData.organisationSite &&
    state.auth.userData.organisationSite.organisation
});

export default connect(mapStateToProps, {
  setUser,
  setApps,
  resetProject,
  getProjectDetails
})(CustomizePlan);
